

import ClientHead from "@/components/main/core/ClientHead";
import RedSection from "@/components/main/core/RedSection";
import CheckBox from "@/components/main/core/CheckBox";
import FormButton from "@/components/main/buttons/FormButton";

export default {

  head() {
    const title = 'Privacy Policy | iFindCheaters';
    const description = 'Read how iFindCheaters protects your privacy. Our Privacy Policy outlines our commitment to safeguarding your personal information. Find more details about our data collection practices, security measures, and your rights under our policy.';

    return {
      title: title,
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: title
        },
        {
          hid: 'description',
          name: 'description',
          content: description
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: description
        },
        {
          hid: 'keywords',
          name: 'keywords',
          content: 'Personal Data Security, Privacy Policy Compliance, GDPR Compliance, Terms and Condition, How to use iFindCheaters, Guidelines to use cheater lookup app'
        },
        {
          hid: 'twitter:title',
          name: 'twitter:title',
          content: title
        }
      ],
      link: [
        {
          hid: "preload",
          rel: "preload",
          as: "image",
          href: require("@/assets/images/main/sample-report-bcg.webp"),
        },
        {
          hid: "canonical",
          rel: "canonical",
          href: "https://ifindcheaters.com/privacy-policy/",
        }
      ],
      script: [
        {
          type: 'application/ld+json',
          body: true,
          json: {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "iFindCheaters",
              "item": "https://ifindcheaters.com/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Privacy policy",
            }],
          }
        }
      ]
    };
  },

  name: "privacy",
  layout: 'clientLayout',
  mixins: [],
  components: {ClientHead, FormButton, RedSection, CheckBox, },
  data() {
    return {
      year: new Date()
    }
  },
  computed: {
    yearNow() {
      return this.year.getFullYear()
    }
  },
  mounted() {
  },
  methods: {}
}
